import { httpClient } from "./httpClient";

const getDashboardRecruit = () => {
  return httpClient.get(`dashboard/recruit`);
};

export default {
  getDashboardRecruit,
};
